<!--
 * @Author: M.D.
 * @Date: 2019-12-23 14:36:31
 * @LastEditors  : lyj
 * @Description: 我的消息、常见问题 、发票下载 列表组件
  // detailType: 0-我的消息 1-常见问题,2-发票下载
     {
 * @Remarks:
 -->
<template>
<div class="qa-list-root">
  <ul class="ui-ul">
    <div v-show="orderNone" class="order-none">
      <img src="@/assets/image/order_none.png" alt="">
      <p>暂无消息
      <p/>
    </div>
    <li class="ui-list-item" v-for="(item,index) in dataList" :key="index" @click="detail(item)">
      <div class="status" style="color: red" v-if="item.isRead == 0">·</div>
      <div class="status" v-if="item.isRead == 1">·</div>
      <div class="status" v-if="item.isRead == undefined"></div>
      <div class="content">
        <div class="title-date">
          <div class="t">{{item.title||item.name}}</div>
          <div class="d">{{item.date}}</div>
          <el-button type="primary" v-if="item.way =='发票下载'" @click="goTarget(item)">{{item.way}}</el-button>
        </div>
        <div class="brief" v-html="(item.content||item.detail).replace(/<[^>]+>/g, ' ')">
        </div>
      </div>
    </li>
    <el-dialog
      ref="qaDetail"
      :lock-scroll="true"
      :visible.sync="detailShow"
      :close-on-click-modal="true"
      width="60%">
      <div class="dialog-header" slot="title">
        {{ question.title || question.name }}
      </div>
      <div class="dialog-info" v-if="question.date">
        <div class="dialog-date">发布时间：{{ question.date }}</div>
      </div>
      <div class="mp-d-content" v-html="question.content || question.detail">
      </div>
      <div slot="footer" style="color: blue;"
        v-if="question.way == '系统通知' && question.detailsLink && question.detailsLink.length > 0"
        @click="redirect(question)">
        查看详情</div>
        <div slot="footer" style="color: blue;"
        v-if="question.way == '订单消息' && question.detailsLink && question.detailsLink.length > 0"
        @click="redirect(question)">
        查看详情</div>
    </el-dialog>
  </ul>

  <div class="order-pagination-w">
    <el-pagination
      background
      v-if="paginationValue.total > 0"
      layout="prev, pager, next"
      @current-change="pageChange"
      :page-size="paginationValue.pageSize"
      :total="paginationValue.total">
    </el-pagination>
  </div>
</div>
</template>

<script>
import API from '@/api/api'
import { mapActions } from 'vuex'
// import $ from 'jquery'
export default {
  props: {
    optionName: {
      default: '',
      type: String
    },
    keyword: {
      default: '',
      type: String
    },
    // dataList: {
    //   default: () => [],
    //   type: Array
    // },
    showStatus: {
      default: false,
      type: Boolean
    },
    // 展示：0-我的消息 1-常见问题,2-发票下载
    detailType: {
      default: 1,
      type: Number
    }
  },
  data () {
    return {
      dataList: [],
      queryParam: {
        currentPage: 1,
        pageSize: 4,
        keyword: '',
        way: this.optionName
      },
      paginationValue: {
        total: 0,
        pageSize: 4
      },
      question: {},
      detailShow: false
    }
  },
  computed: {
    orderNone () {
      return !`${this.dataList}`
    }
  },
  created () {

  },
  mounted () {
  },
  activated () {
    this.getData()
  },
  deactivated () {

  },
  watch: {
    optionName: function (v) {
      this.queryParam.way = v
      this.queryParam.currentPage = 1
      this.getData()
    },
    keyword: function (v) {
      this.queryParam.keyword = v
      this.getData()
    },
    detailShow: function (v) {
      if (v) {
        console.log('truesa')
      }
    }
  },
  methods: {
    ...mapActions(['getUnreadCount']),
    getData () {
      if (this.detailType === 0) {  //我的消息
        this.getMessageList()
      } else  if (this.detailType === 1){  //知识问答
        this.getKnowledge()
      }
      else  if (this.detailType === 2){  //发票下载
        this.getInvoiceDown()
      }
    },
    goTarget(item){ //lyj
      if(item.targetId){
        window.open(`${item.targetId}`, '_blank')
      }

    },
    async getMessageList () {
      const res = await API.getMessageList(this.queryParam)
      this.dataList = res.data.result.records
      this.paginationValue.total = parseInt(res.data.result.total)
      this.messageList = res.data.result.records
    },
    async getKnowledge () {
      const res = await API.getKnowledge(this.queryParam)
      this.dataList = res.data.result.records
      this.paginationValue.total = parseInt(res.data.result.total)
      //console.log(this.paginationValue.total)
    },
    async getInvoiceDown () {
      const res = await API.getInvoiceDown(this.queryParam)
      //console.log("getinvoice res:")
      console.log(res)
      //alert(res.data.result)
      this.dataList = res.data.result
      //this.paginationValue.total = parseInt(res.data.result.total)
      //alert(this.dataList.length)
      this.paginationValue.total = this.dataList.length
      console.log(this.paginationValue.total)
    },
    pageChange (currentPage) {
      this.queryParam.currentPage = currentPage
      this.getData()
    },
    redirect (item) {
      this.detailShow = false
      let url = item.detailsLink
      console.log(url)
      if (item.way === '订单消息') {
        this.$router.push({ name: 'orderDetail', params: { orderId: item.detailsLink } })
        return
      }
      window.open(`${url}`, '_blank')
    },
    detail (item) {
      this.question = item
      if (this.detailType === 0) {
        this.detailShow = true
        this.clearUnread(item)
      } else {
        this.$emit('onclickQa', item)
      }
    },
    async clearUnread (item) {
      const res = await API.updateMsgIsRead({
        id: item.noticeUserRelationId
      })

      if (res.data.statusCode === '200' && res.data.result) {
        item.isRead = 1
        this.getUnreadCount()
      }
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.qa-list-root

  .order-pagination-w
    text-align right
    margin-top 20px
    right 30px
    bottom 40px
  .dialog-header
    font-size 25px
    height 100%
  .dialog-info
    width 100%
    height 50px
    .dialog-author
      display inline
      font-size 12px
      line-height 50px
      color #999
      margin-right 8px
    .dialog-date
      font-size 12px
      display inline
      line-height 50px
      color #999
  .ui-ul
    .order-none
      width 100%
      text-align center
      padding-top 100px
    p
      color #dddddd
    .ui-list-item
      height 110px
      display flex
      box-sizing border-box
      padding 10px 40px 10px 0
      .status
        text-align center
        color #DFDFDF
        flex 0 0 40px
        font-size 30px
      .content
        display grid
        flex 1 1 auto
        border-bottom 1px solid #dddddd
        .title-date
          flex-ltr-parent()
          .t
            height 40px
            line-height 34px
            color #333333
            font-size 16px
          .d
            height 28px
            line-height 28px
            font-size 14px
            color #999999
        .brief
          height 40px
          line-height 40px
          font-size 14px
          color #8C8C8C
          ellipsis2(1)
    .mp-d-content
      overflow-x auto
      overflow-y scroll
      font-size 20px
      line-height 26px
</style>
